import React from "react";
import { motion } from "framer-motion";
// import { photos } from "../../../assets";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper";

import "./index.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";

// Import all images dynamically from assets/fotos
const importAll = (r) => {
  return r.keys().map(r);
};
const photos = importAll(
  require.context("../../../assets/fotos", false, /\.(png|jpe?g|svg)$/)
);

const Galeria = ({ variants }) => {
  // Ajuste dinámico de configuración Swiper
  const slideCount = photos.length;
  // Loop requiere al menos el doble de slides que slidesPerView para funcionar perfecto en algunas versiones,
  // pero mínimo debe tener más slides que los visibles.
  // Safety check: si hay 0 fotos, no mostrar swiper o mostrar mensaje.

  const slidesPerView = slideCount < 3 ? slideCount : 3;
  const enableLoop = slideCount > 3;

  if (slideCount === 0) return null; // O un placeholder

  return (
    <div className="section darkSec noPadTop">
      <div className="container-lg flex flexCol">
        <motion.h3
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.3}
          className="textCenter"
        >
          Gallery
        </motion.h3>

        <Swiper
          className="galeria"
          effect={"coverflow"}
          modules={[Autoplay, EffectCoverflow]}
          grabCursor={true}
          speed={1500}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
          }}
          loop={enableLoop}
          slidesPerView={slidesPerView > 0 ? slidesPerView : "auto"}
          key={slideCount} // Forzar re-render si cambia la cantidad
        >
          {photos.map((photo, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
                <motion.img
                  variants={variants}
                  initial={"initial"}
                  whileInView={"ani"}
                  className={isActive ? "activeSlide" : ""}
                  viewport={{ once: true }}
                  custom={index * 0.2}
                  src={photo}
                  alt={`Gallery image ${index + 1}`}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Galeria;
